const tempProducts = [
  {
    id: 1,
    name: "PT100 Temperature Sensor",
    description: "High-accuracy RTD sensor for industrial temperature measurement.",
    image: "/assets/sensors/TEMP.png",
    pdf: "/assets/pdf/sample.pdf",   // update path to actual datasheet
    price: "₹850"
  },
  {
    id: 2,
    name: "Type-K Thermocouple",
    description: "Wide-range thermocouple ideal for furnaces and high heat zones.",
    image: "/assets/sensors/TEMP.png",
    pdf: "/assets/pdf/sample.pdf",
    price: "₹650"
  },
  {
    id: 3,
    name: "Digital Temperature Transmitter",
    description: "4-20mA output, stainless steel housing, high stability.",
    image: "/assets/sensors/TEMP.png",
    pdf: "/assets/pdf/sample.pdf",
    price: "₹2,800"
  }
];

export default tempProducts;
